import React, {useEffect, useState} from "react";
import {
    CalendarOutlined,
    CheckOutlined,
    FileExcelOutlined,
    LogoutOutlined,
    UploadOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Button, DatePicker, Dropdown, Layout, message, Select, Space, Typography, Upload, UploadFile, UploadProps} from "antd";
import {useAuth} from "../auth/AuthProvider";
import axios from "axios";
import {Dayjs} from "dayjs";
import ruRU from 'antd/es/date-picker/locale/ru_RU'

const {Header, Content} = Layout;
const {Title} = Typography;


type DictionaryData = {
    types: {
        label: string;
        value: string
    }[];
    dates: {
        label: string;
        value: string
    }[];
};

const Dashboard = () => {
    const {logout, user} = useAuth();

    const [date, setDate] = useState<Dayjs | null>(null);
    const [type, setType] = useState<string | undefined>(undefined);
    const [dictionary, setDictionary] = useState<DictionaryData | null>(null);
    const [fileList, setFileList] = useState<UploadFile[]>([])
    const [uploading, setUploading] = useState(false);

    const handleUpload = () => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('file', file as any);
        });
        formData.append('date', date?.format('MMMM YYYY') as string)
        formData.append('type', type as string)
        setUploading(true)

        axios.post('api/v1/file', formData, {
            withCredentials: true,
        })
            .then(() => {
                setFileList([]);
                message.success('Загрузка завершена.');
            })
            .catch(() => {
                message.error('Загрузка не удалась.');
            })
            .finally(() => {
                setUploading(false);
            });
    };

    const handleDelete = () => {
        axios.delete('api/v1/file', {
            withCredentials: true,
            params: {
                date: date?.format('MMMM YYYY'),
                type
            }
        })
            .then(() => {
                setFileList([]);
                message.success('Удаление завершено.');
            })
            .catch(() => {
                message.error('Удаление не удалось.');
            })
            .finally(() => {
                setUploading(false);
            });
    }

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `${window.location.origin}/api/v1/file?date=${date?.format('MMMM YYYY')}&type=${type}`;
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const props: UploadProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([...fileList, file]);

            return false;
        },
        fileList,
        maxCount: 1,
        accept: '.xls,.xlsx'
    };

    useEffect(() => {
        axios.get('api/v1/file/dictionary', {
            withCredentials: true,
        }).then(({data}) => {
            const types = Object.keys(data.types).map((q) => ({value: q, label: data.types[q]}))
            const dates = data.dates.map((date: string) => ({value: date, label: date}))
            setDictionary({dates, types})
        })
    }, []);

    const userMenu = {
        items: [
            {
                key: "logout",
                icon: <LogoutOutlined/>,
                label: "Выход",
                onClick: logout,
            },
        ],
    };

    return (
        <Layout style={{minHeight: "100vh"}}>
            <Header
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "#5c5c5c",
                    color: "#fff",
                }}
            >
                <div style={{fontSize: 18, fontWeight: 500}}>ASITECH LK</div>

                <Dropdown menu={userMenu} trigger={["click"]}>
                    <div style={{cursor: "pointer"}}>
                        <Space>
                            <UserOutlined/>
                            ООО Фирма СТОМ
                        </Space>
                    </div>
                </Dropdown>
            </Header>

            <Content style={{padding: 24, background: "#f0f2f5"}}>
                <div
                    style={{
                        background: "#fff",
                        padding: 16,
                        borderRadius: 8,
                        marginBottom: 16,
                    }}
                >
                    <Title level={5}>ВЫБЕРИТЕ ПЕРИОД</Title>

                    <Space size="middle" wrap>

                        <DatePicker
                            locale={ruRU}
                            picker="month"
                            value={date}
                            onChange={setDate}
                            format="MMMM YYYY"
                            style={{width: 220}}
                            placeholder="Выберите период"
                            suffixIcon={<CalendarOutlined/>}
                        />

                        <Select
                            value={type}
                            onChange={setType}
                            style={{width: 300}}
                            placeholder="Продукт"
                            menuItemSelectedIcon={<CheckOutlined/>}
                            options={dictionary?.types}
                        />

                        {user?.is_admin && <Upload {...props}>
                            <Button icon={<UploadOutlined/>}>Выберите XLS</Button>
                        </Upload>}

                    </Space>
                </div>

                <div
                    style={{
                        background: "#fff",
                        borderRadius: 8,
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            background: "#6fa8dc",
                            color: "#fff",
                            padding: "12px 16px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <span>{date?.format('MMMM YYYY')}</span>

                        {user?.is_admin ?
                            <>
{/*                                <Button
                                    onClick={handleDelete}
                                >
                                    delete
                                </Button>*/}
                                <Button
                                    onClick={handleUpload}
                                    loading={uploading}
                                    disabled={!date || !type || !fileList.length}
                                    icon={<UploadOutlined/>}>
                                    Загрузить XLS
                                </Button>
                            </>
                            :
                            <Button
                                onClick={handleDownload}
                                disabled={!date || !type}
                                icon={<FileExcelOutlined/>}
                            >
                                Скачать XLS
                            </Button>
                        }

                    </div>

                </div>
            </Content>
        </Layout>
    );
};

export default Dashboard